import React, { useEffect, useContext, useReducer} from 'react'
import { CategoryContext } from './CategoryContext'
import { useLazyQuery } from "@apollo/client"
import { GET_CATEGORIES } from "../../graphql"
import { UserContext } from "../index"
import {AUTH_LOGIN, CATEGORIES_ACTION} from "../../constant"

const initialCategories = []

const categoriesReducer = (state, action) => {
	switch (action.type){
		case CATEGORIES_ACTION.ADD_CATEGORIES: {
			return state.concat(action.payload)
		}
		case CATEGORIES_ACTION.SET_CATEGORIES: {
			return action.payload
		}
		case CATEGORIES_ACTION.RESET: {
			return initialCategories
		}
		default: {
			return state
		}
	}
}

export function CategoryProvider({ children }){
	const {user} = useContext(UserContext)
	const [categories, dispatch] = useReducer(categoriesReducer, initialCategories)
	const [getCategories, { loading, data }] = useLazyQuery(GET_CATEGORIES)

	useEffect(() => {
		if(user?.auth === AUTH_LOGIN){
			getCategories()
		}
	}, [getCategories, user])

	useEffect(() => {
		if(data){
			dispatch({type: CATEGORIES_ACTION.SET_CATEGORIES, payload: data?.categories || []})
		}
	}, [data, loading])

	return (
		<CategoryContext.Provider value={{
			categories,
			setCategories: (category) => dispatch({type: CATEGORIES_ACTION.ADD_CATEGORIES, payload: category}),
			resetCategories: (category) => dispatch({type: CATEGORIES_ACTION.RESET}),
		}}>
			{children}
		</CategoryContext.Provider>
	)
}
